import displayModal from 'root/src/client/logic/modal/actions/displayModal'
import { showOverflow } from 'root/src/client/v2/common/contexts/modal.context'

export default (modalModuleId, props, modalRouteId) => (dispatch) => {
	if (!modalModuleId) {
		showOverflow()
	}
	dispatch(
		displayModal(modalModuleId, props, modalRouteId),
	)
}
